import React from 'react';

import './styles.scss';

import HeaderApp from 'components/Header/HeaderApp';
// import PageTitle from 'components/_base/PageTitle';
import Bottom from 'components/Bottom';
import ContentPendenciaDemanda from './ContentPendeciaDemanda';

const Pendencias = () => {
  return (
    <>
      <HeaderApp />
      <ContentPendenciaDemanda />
      <Bottom />
    </>
  );
};

export default Pendencias;
